import {useEffect} from "react";

// Keep the outlet mounted: changing tabs must never erase an intake draft.
export default function usePageMotion(ref, route) {
  useEffect(() => {
    if (!ref.current || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const animation = ref.current.animate([{opacity:0.45},{opacity:1}], {duration:260,easing:"cubic-bezier(.2,.7,.2,1)"});
    return () => animation.cancel();
  }, [ref, route]);
}
